import React, { Component } from 'react';
import 'HELPDESK/Components/OnboardingDetails/OnboardingSteps/onboardingsteps.css';
import config from 'config';
import HelpdeskApiCall from 'HelpdeskApiCall';
import ReactHtmlParser from 'react-html-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactToPrint from 'react-to-print';
import moment from 'moment';
import Spinner from 'HELPDESK/CommonResources/SpinnerLoader/Spinner';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';

class OnboardingSteps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subDetails: this.props.subDetails,
            onboardingStepFetching: false,
            onboardingStepList: {},
            sequenceArray: [],
            sequenceIdArray:[],

            // VARIABLES TO GET SPOC DETAILS
            spocDetails: {},
            spocId: '',
            spocName: '',

            // VARIABLES TO GET ATTENDEE LIST
            attendeeFetching: false,
            attendeeList: {},

            // VARIABLES TO GET TIME SLOT
            timeSlot: {},

            // VARIABLES TO SCHEDULE DEMO
            scheduleDemo: false,
            schedulingDemo: false,
            meetingName: '',
            selectedModule: {},
            selectAttendees: false,
            tempSelectedAttendees: {},
            selectedAttendees: {},
            attendeeWarning: '',
            meetingDate: '',
            meetingDateWarning: '',
            selectedTimeSlotId: '',
            selectedTimeSlot: '',
            timeSlotWarning: '',
            stepUniqueId: '',

            // VARIABLES TO GET INDIVIDUAL STEP DETAILS
            individualStepFetching: false,
            individualStepDetails: {},
        };
    }

    componentDidMount() {
        // METHOD CALLED TO GET ONBOARDING STEP LIST
        this.apiCallToGetAssignedModule();
        
        // METHOD CALLED TO GET ATTENDEE LIST
        // this.apiCallToGetAttendeeList();
        
        // METHOD CALLED TO GET SPOC DETAILS
        // this.apiCallToGetSPOCDetails();
    }
    showEmployeeName = (employeeObjet) =>{
        return Object.values(employeeObjet).toString().length> 50? Object.values(employeeObjet).join(", ")+"...":Object.values(employeeObjet).join(", ");
    }
    // API CALL METHOD TO GET ONBOARDING STEP LIST
    apiCallToGetAssignedModule = async () => {
        this.setState({
            onboardingStepFetching: true,
        });

        let requestData = {
            "subscriptionTypeId": this.state.subDetails.subscription_id,
            "iid": config.institute_id,
            "subscriptionId": this.state.subDetails.unique_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'getAssignedModule',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAssignedModule()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                let sequenceIdArray = jsonResponse.APIResult.sequenceIdArray;
                this.setState({
                    onboardingStepFetching: false,
                    onboardingStepList: apiResult,
                    sequenceIdArray,
                });
            } else {
                this.setState({
                    onboardingStepFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting onboarding step list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET ATTENDEE LIST
    apiCallToGetAttendeeList = async () => {
        this.setState({
            attendeeFetching: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "department":'',
            "search": this.state.searchTerm
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'getEmployeeDetails',
            requestData,
            '/api/employee/employee.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAttendeeList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    attendeeFetching: false,
                    attendeeList: apiResult
                });
            } else {
                this.setState({
                    attendeeFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting attendee list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET SPOC DETAILS
    apiCallToGetSPOCDetails = async () => {
        let requestData = {
            "institute_id": config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetPMIndividualInstituteSpocList',
            requestData,
            '/api/projectManagement/client/spoc.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetSPOCDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if(Object.keys(apiResult).length > 0) {
                    Object.values(apiResult).map(spoc => {
                        if(spoc.type == "primary spoc")
                        {
                            this.setState({
                                spocId: spoc.employee_id,
                                spocName: spoc.spoc_name
                            });
                        }
                    });
                }

                this.setState({
                    spocDetails: apiResult
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting spoc details. Please try again later.'
                });
            }
        }
    }

    // METHOD TO FORMAT DATE
    formatDate = (d) =>{
        var date = new Date(d);

        if (isNaN(date.getTime())) {
            return "";
        }else{  
            var month = new Array();
            month[0] = "January";
            month[1] = "February";
            month[2] = "March";
            month[3] = "April";
            month[4] = "May";
            month[5] = "June";
            month[6] = "July";
            month[7] = "August";
            month[8] = "September";
            month[9] = "October";
            month[10] = "November";
            month[11] = "December";

            let day = date.getDate();
            
            if(day < 10) {
                day = "0"+day;
            }
            return day  + " " +month[date.getMonth()] + ", " + date.getFullYear();
        }       
    }

    // METHOD TO EXPAND STEP 
    // expandStep = (stepId) => {
    //     let onboardingStepList = this.state.onboardingStepList;
    //     onboardingStepList[stepId].expanded = true;
    //     Object.keys(onboardingStepList).map(stepUid => {
    //         if(stepUid != stepId) {
    //             onboardingStepList[stepUid].expanded = false;
    //         }
    //     });

    //     this.setState({
    //         onboardingStepList,
    //         stepUniqueId: stepId
    //     }, () => {
    //         // METHOD CALLED TO GET INDIVIDUAL STEP DETAILS
    //         this.apiCallToGetIndividualStepDetails();
    //     });
    // }

    // API CALL METHOD TO GET INDIVIDUAL STEP DETAILS
    // apiCallToGetIndividualStepDetails = async () => {
    //     this.setState({
    //         individualStepFetching: true
    //     });

    //     let requestData = {
    //         "subscriptionTypeId": this.state.subDetails.subscription_id,
    //         "clientSubscriptionUID": this.state.subDetails.unique_id,
    //         "stepId": this.state.stepUniqueId,
    //         "iid": config.institute_id
    //     };

    //     let jsonResponse = await HelpdeskApiCall.makeApiCall(
    //         'GetIndividualOnboardingStepsDetails',
    //         requestData,
    //         '/api/helpDesk/employee/Onboarding.php'
    //     );

    //     if (jsonResponse.expired) {
    //         setTimeout(() => {
    //             this.apiCallToGetIndividualStepDetails()
    //         }, 1000);
    //     } else {
    //         if (jsonResponse.success) {
    //             let apiResult = jsonResponse.APIResult.data;
    //             if(Object.keys(apiResult).length > 0) {
    //                 apiResult = Object.values(apiResult)[0];
    //             }
    //             this.setState({
    //                 individualStepFetching: false,
    //                 individualStepDetails: apiResult
    //             });
    //         } else {
    //             this.setState({
    //                 individualStepFetching: false,
    //                 successModal: true,
    //                 successModalType: 'error',
    //                 successMessage: 'Something went wrong while getting individual step details. Please try again later.'
    //             });
    //         }
    //     }
    // }

    // // METHOD TO COLLAPSE STEP 
    // collapseStep = (stepId) => {
    //     let onboardingStepList = this.state.onboardingStepList;
    //     onboardingStepList[stepId].expanded = false;
    //     this.setState({
    //         onboardingStepList
    //     });
    // }

    // // METHOD TO GET SCHEDULE DEMO DETAILS
    // scheduleDemoDetails = (step, type) => {
    //     if(type == 'button') {
    //         this.setState({
    //             scheduleDemo: true,
    //             meetingName: step.stepName,
    //             selectedModule: step.moduleObject,
    //             stepUniqueId: step.stepUid
    //         });
    //     }else if(type == 'link') {
    //         this.setState({
    //             scheduleDemo: true,
    //             meetingName: step.stepName,
    //             selectedModule: step.moduleObject,
    //             stepUniqueId: step.stepUid
    //         });
    //     }
    // }

    // // METHOD TO RETURN SCHEDULE DEMO SLIDER
    // returnScheduleDemo = () => {
    //     return(
    //         <div id="scheduleDemoSlider" style={{ display: this.state.scheduleDemo ? 'flex' : 'none' }}>
    //             <div id="scheduleDemoDataContainer">
    //                 <div id="scheduleDemoHeader" className="row">
    //                     <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeScheduleDemo()} style={{ cursor: "pointer" }} />
    //                     <h5 className="col-11">Schedule Demo</h5>
    //                 </div>
    //                 <div id="scheduleDemoBody" className="col-md-12">
    //                     <div className="meetingName">
    //                         <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Meeting Name</label>
    //                         <p style={{ fontSize: 14 }}>{this.state.meetingName}</p>
    //                     </div>
    //                     <div className="modules">
    //                         <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Modules</label>
    //                         <p style={{ fontSize: 14 }}>{Object.values(this.state.selectedModule).join(", ")}</p>
    //                     </div>
    //                     <div className="selectAttendees">
    //                         <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Select Attendee(s) <span style={{ color: 'red' }}>*</span></label>
    //                         <input
    //                             type="text"
    //                             placeholder="Click here to select attendee(s)"
    //                             className="form-control scheduleDemoInput"
    //                             readOnly
    //                             onClick={() => this.setState({ selectAttendees: true })}
    //                         />
    //                         {
    //                             Object.keys(this.state.selectedAttendees).length > 0 &&
    //                                 Object.keys(this.state.selectedAttendees).map(employeeId => {
    //                                     return(
    //                                         <div className="selected-attendee">
    //                                             <p style={{ fontSize: 14 }}>
    //                                                 {this.state.selectedAttendees[employeeId]}
    //                                                 <FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.removeAttendee(employeeId)} />
    //                                             </p>
    //                                         </div>
    //                                     );
    //                                 })
    //                         }
    //                         <p className="text-danger" style={{ fontSize: 14 }}>{this.state.attendeeWarning}</p>
    //                     </div>
    //                     <div className="meetingDate">
    //                         <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Date <span style={{ color: 'red' }}>*</span></label>
    //                         <input
    //                             type="date"
    //                             className="form-control scheduleDemoInput"
    //                             value={this.state.meetingDate}
    //                             onChange={(e) => this.getMeetingDate(e)}
    //                         />
    //                         <p className="text-danger" style={{ fontSize: 14 }}>{this.state.meetingDateWarning}</p>
    //                     </div>
    //                     <div className="meetingSlot">
    //                         <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Time Slot <span style={{ color: 'red' }}>*</span></label>
    //                         <select
    //                             className="form-control scheduleDemoInput"
    //                             disabled={this.state.meetingDate == ''}
    //                             value={this.state.selectedTimeSlotId}
    //                             onChange={(e) => this.getMeetingSlot(e)}
    //                         >
    //                             <option value="">Select Time Slot</option>
    //                             {
    //                                 (this.state.timeSlot[this.state.meetingDate] != undefined) && (Object.keys(this.state.timeSlot).length > 0 && this.state.meetingDate.length > 0) &&
    //                                     Object.values(this.state.timeSlot[this.state.meetingDate]).map(slot => {
    //                                         return(
    //                                             <option key={slot.uniqueid} value={slot.uniqueid}>
    //                                                 {slot.start_time} - {slot.end_time}
    //                                             </option>
    //                                         );
    //                                     })
                                    
                                    
    //                             }
    //                         </select>
    //                         <p className="text-danger" style={{ fontSize: 14 }}>{this.state.timeSlotWarning}</p>
    //                     </div>
    //                 </div>
    //                 <div id="scheduleDemoFooter" style={{ marginBottom: 10 }}>
    //                     {
    //                         this.state.schedulingDemo &&
    //                             <ButtonLoader />
    //                     }
    //                     <button className="btn btn-primary" onClick={() => this.validateDemoDetails()} disabled={this.state.schedulingDemo}>Schedule</button>
    //                     <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeScheduleDemo()}>Cancel</button>
    //                 </div>
    //             </div>
    //         </div >
    //     );
    // }

    // // METHOD TO RETURN SELECT ATTENDEES MODAL
    // returnSelectAttendees = () => {
    //     return(
    //         <div className={this.state.selectAttendees ? "modal fade show" : "modal fade"} id="modalContainer" >
    //             <div className="modal-dialog modal-dialog-centered">
    //                 <div className="modal-content">
    //                     <div className="modal-header">
    //                         <div className="icon-container">
    //                             <FontAwesomeIcon icon={['fas', 'user']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
    //                         </div>
    //                         <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Select Attendees</h3>
    //                         <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.closeSelectAttendees()}/>
    //                     </div>
    //                     <div className="modal-body selectAttendees-body">
    //                         <div className="searchName">
    //                             <FontAwesomeIcon icon={['fas', 'search']} color="#495057" className="search-icon" />
    //                             <input
    //                                 type="text"
    //                                 className="form-control searchInput"
    //                                 placeholder="Search Attendee" 
    //                                 onChange={(e)=>this.setState({ searchTerm: e.target.value })} 
    //                                 value={this.state.searchTerm}
    //                                 onKeyPress={(e) => this.searchAttendee(e)}
    //                             />
    //                         </div>
    //                         <p className="info-msg">Press enter to search.</p>
    //                         <div className="attendeeList">
    //                             {
    //                                 this.state.attendeeFetching ?
    //                                     <ButtonLoader />
    //                                 :
    //                                     Object.keys(this.state.attendeeList).length > 0 ?
    //                                         Object.values(this.state.attendeeList).map(attendee => {
    //                                             return(
    //                                                 <div className="attendee">
    //                                                     <input
    //                                                         type='checkbox'
    //                                                         style={{ marginRight: 5 }}
    //                                                         checked={this.state.tempSelectedAttendees[attendee.FacultyId] != undefined}
    //                                                         onClick={(e) => this.selectAttendeeDetails(e, attendee)}
    //                                                     />
    //                                                     <span>{attendee.FirstName} {attendee.LastName}</span>
    //                                                 </div>
    //                                             );
    //                                         })
    //                                     :
    //                                         <p>No attendee details found.</p>
    //                             }
    //                         </div>
    //                     </div>
    //                     <div className="modal-footer">
    //                         <button className="btn primary-button" onClick={() => this.confirmAttendeeSelection()}>Select</button>
    //                         <button className="btn outline-button" onClick={() => this.closeSelectAttendees()}>Cancel</button>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

    // // METHOD TO SEARCH ATTENDEE
    // searchAttendee = (e) => {
    //     if(e.charCode == 13) {
    //         this.apiCallToGetAttendeeList();
    //     }
    // }
    
    // // METHOD TO SELECT ATTENDEES DETAILS
    // selectAttendeeDetails = (e, attendee) => {
    //     let tempSelectedAttendees = this.state.tempSelectedAttendees;
    //     if(e.target.checked) {
    //         if(tempSelectedAttendees[attendee.FacultyId] == undefined) {
    //             tempSelectedAttendees[attendee.FacultyId] = '';
    //         }
    //         tempSelectedAttendees[attendee.FacultyId] = attendee.FirstName + ' ' + attendee.LastName;
    //     }else {
    //         delete tempSelectedAttendees[attendee.FacultyId];
    //     }

    //     this.setState({
    //         tempSelectedAttendees
    //     });
    // }

    // // METHOD TO CONFIRM ATTENDEE SELECTION
    // confirmAttendeeSelection = () => {
    //     let selectedAttendees = this.state.selectedAttendees;
    //     if(Object.keys(this.state.tempSelectedAttendees).length > 0) {
    //         Object.keys(this.state.tempSelectedAttendees).map(employeeId => {
    //             if(selectedAttendees[employeeId] == undefined) {
    //                 selectedAttendees[employeeId] = '';
    //             }
    //             selectedAttendees[employeeId] = this.state.tempSelectedAttendees[employeeId];
    //         });
    //     }else {
    //         selectedAttendees = {};
    //     }

    //     if(Object.keys(selectedAttendees).length > 0) {
    //         this.setState({
    //             attendeeWarning: ''
    //         });
    //     }else {
    //         this.setState({
    //             attendeeWarning: 'Please select attendee(s).'
    //         });
    //     }

    //     this.setState({
    //         selectAttendees: false,
    //         selectedAttendees
    //     });
    // }

    // // METHOD TO CLOSE SELECT ATTENDEES MODAL
    // closeSelectAttendees = () => {
    //     let tempSelectedAttendees = this.state.tempSelectedAttendees;
    //     if(Object.keys(this.state.selectedAttendees).length > 0) {
    //         Object.keys(this.state.selectedAttendees).map(employeeId => {
    //             if(tempSelectedAttendees[employeeId] == undefined) {
    //                 tempSelectedAttendees[employeeId] = '';
    //             }
    //             tempSelectedAttendees[employeeId] = this.state.selectedAttendees[employeeId];
    //         });
    //     }else {
    //         tempSelectedAttendees = {};
    //     }
    //     this.setState({
    //         selectAttendees: false,
    //         tempSelectedAttendees,
    //     });
    // }

    // // METHOD TO REMOVE SELECTED ATTENDEES
    // removeAttendee = (employeeId) => {
    //     let selectedAttendees = this.state.selectedAttendees;
    //     let tempSelectedAttendees = this.state.tempSelectedAttendees;
    //     delete selectedAttendees[employeeId];
    //     delete tempSelectedAttendees[employeeId];
    //     this.setState({
    //         selectedAttendees,
    //         tempSelectedAttendees
    //     });
    // }

    // // METHOD TO GET MEETING DATE
    // getMeetingDate = (e) => {
    //     let meetingDate = this.state.meetingDate;
    //     meetingDate = e.target.value;

    //     if(e.target.value.length < 1) {
    //         this.setState({
    //             meetingDate,
    //             selectedTimeSlotId: '',
    //             selectedTimeSlot: '',
    //             meetingDateWarning: 'Please select meeting date.'
    //         });
    //     }else {
    //         this.setState({
    //             meetingDate,
    //             meetingDateWarning: ''
    //         }, () => {
    //             this.apiCallToGetTimeSlot(meetingDate);
    //         });
    //     }
    // }

    // // API CALL METHOD TO GET TIME SLOT
    // apiCallToGetTimeSlot = async () => {
    //     let requestData = {
    //         "emp_id": this.state.spocId,
    //         "start_date": this.state.meetingDate,
    //         "end_date": this.state.meetingDate,
    //         "isAvailable":"true"
    //     };

    //     let jsonResponse = await HelpdeskApiCall.makeApiCall(
    //         'GetPMTimeSlotList',
    //         requestData,
    //         '/api/projectManagement/timeSlot/timeSlot.php'
    //     );

    //     if (jsonResponse.expired) {
    //         setTimeout(() => {
    //             this.apiCallToGetTimeSlot()
    //         }, 1000);
    //     } else {
    //         if (jsonResponse.success) {
    //             let apiResult = jsonResponse.APIResult.data;
    //             this.setState({
    //                 timeSlot: apiResult
    //             });
    //         } else {
    //             this.setState({
    //                 successModal: true,
    //                 successModalType: 'error',
    //                 successMessage: 'Something went wrong while getting available time slots. Please try again later.'
    //             });
    //         }
    //     }
    // }

    // // METHOD TO GET MEETING SLOT
    // getMeetingSlot = (e) => {
    //     this.setState({
    //         selectedTimeSlotId: e.target.value
    //     });

    //     if(e.target.value.length < 1) {
    //         this.setState({
    //             timeSlotWarning: 'Please select meeting slot.',
    //             selectedTimeSlot: ''
    //         });
    //     }else {
    //         this.setState({
    //             timeSlotWarning: '',
    //             selectedTimeSlot: e.target.selectedOptions[0].text
    //         });
    //     }
    // }

    // // METHOD TO VALIDATE DEMO DETAILS
    // validateDemoDetails = () => {
    //     let validData = true;
        
    //     if(Object.keys(this.state.selectedAttendees).length < 1) {
    //         this.setState({
    //             attendeeWarning: 'Please select attendee(s).'
    //         });
    //         validData = false;
    //     }

    //     if(this.state.meetingDate.length < 1) {
    //         this.setState({
    //             meetingDateWarning: 'Please select meeting date.'
    //         });
    //         validData = false;
    //     }

    //     if(this.state.selectedTimeSlotId.length < 1) {
    //         this.setState({
    //             timeSlotWarning: 'Please select meeting slot.'
    //         });
    //         validData = false;
    //     }

    //     if(validData) {
    //         // METHOD CALLED TO SCHEDULE DEMO
    //         this.apiCallToScheduleDemo();
    //     }
    // }

    // // API CALL METHOD TO SCHEDULE DEMO
    // apiCallToScheduleDemo = async () => {
    //     this.setState({
    //         schedulingDemo: true
    //     });

    //     let requestData = {
    //         "meeting_name": this.state.meetingName,
    //         "iid": config.institute_id,
    //         "meeting_type": "onboarding",
    //         "module_id_array": Object.keys(this.state.selectedModule),
    //         "client_attendees": Object.keys(this.state.selectedAttendees),
    //         "vm_team_attendees": [this.state.spocId],
    //         "demo_date": this.state.meetingDate,
    //         "start_time": this.state.selectedTimeSlot.split(' - ')[0],
    //         "end_time": this.state.selectedTimeSlot.split(' - ')[1],
    //         "online_offline_meeting": "Online",
    //         "facultyId": config.faculty_id,
    //         "timeslotUID": this.state.selectedTimeSlotId,
    //         "subscription_id": this.state.subDetails.subscription_id,
    //         "client_subscription_id": this.state.subDetails.unique_id,
    //         "step_id": this.state.stepUniqueId,
    //         'meeting_type': 'onboarding'
    //     };

    //     let jsonResponse = await HelpdeskApiCall.makeApiCall(
    //         'AddClientDemoFromHelpDesk',
    //         requestData,
    //         '/api/helpDesk/employee/Onboarding.php'
    //     );

    //     if (jsonResponse.expired) {
    //         setTimeout(() => {
    //             this.apiCallToScheduleDemo()
    //         }, 1000);
    //     } else {
    //         if (jsonResponse.success) {
    //             let apiResult = jsonResponse.APIResult;
    //             if(apiResult.status == 'success') {
    //                 let onboardingStepList = this.state.onboardingStepList;
    //                 onboardingStepList[this.state.stepUniqueId]['clientAttendeesCount'] = Object.keys(this.state.selectedAttendees).length;
    //                 onboardingStepList[this.state.stepUniqueId]['demoId'] = apiResult.UID;
    //                 onboardingStepList[this.state.stepUniqueId]['actualDate'] = this.state.meetingDate;
    //                 onboardingStepList[this.state.stepUniqueId]['meetingType'] = 'onboarding';
    //                 onboardingStepList[this.state.stepUniqueId]['startTime'] = this.state.selectedTimeSlot.split(' - ')[0];
    //                 onboardingStepList[this.state.stepUniqueId]['endTime'] = this.state.selectedTimeSlot.split(' - ')[1];
                
    //                 let startTime = moment(this.state.selectedTimeSlot.split(' - ')[0], 'hh:mm:ss');
    //                 let endTime = moment(this.state.selectedTimeSlot.split(' - ')[1], 'hh:mm:ss');
    //                 let minutes = endTime.diff(startTime, 'minutes');

    //                 onboardingStepList[this.state.stepUniqueId]['durationInMin'] = minutes;

    //                 this.closeScheduleDemo();

    //                 this.setState({
    //                     successModal:true,
    //                     successModalType: 'success',
    //                     successMessage: apiResult.message,
    //                     onboardingStepList,
    //                     schedulingDemo: false
    //                 });
    //             }else {
    //                 this.setState({
    //                     successModal:true,
    //                     successModalType: 'warning',
    //                     successMessage: apiResult.message,
    //                     schedulingDemo: false
    //                 });
    //             }
    //         } else {
    //             this.setState({
    //                 schedulingDemo: false,
    //                 successModal: true,
    //                 successModalType: 'error',
    //                 successMessage: 'Something went wrong while scheduling demo. Please try again later.'
    //             });
    //         }
    //     }
    // }

    // // METHOD TO CLOSE SCHEDULE DEMO
    // closeScheduleDemo = () => {
    //     this.setState({
    //         scheduleDemo: false,
    //         schedulingDemo: false,
    //         meetingName: '',
    //         selectedModule: {},
    //         selectAttendees: false,
    //         tempSelectedAttendees: {},
    //         selectedAttendees: {},
    //         attendeeWarning: '',
    //         meetingDate: '',
    //         meetingDateWarning: '',
    //         selectedTimeSlotId: '',
    //         selectedTimeSlot: '',
    //         timeSlotWarning: ''
    //     });
    // }
    
    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    render() {
        return (
            <>
                <div className="subStepsContainer">
                    <div className="subStepsHeader">
                        <div className="subSteps-details col-md-6" style={{ paddingLeft: 0 }}>
                            <FontAwesomeIcon icon={['far','arrow-alt-circle-left']} size="lg" style={{ marginRight: 5, cursor: 'pointer' }} onClick={() => this.props.closeOnboardingSteps()} />
                            <p style={{ fontWeight: 'bold', fontSize: 14 }}>{this.state.subDetails.subscription_type}</p>
                            <p style={{ fontWeight: 'bold', fontSize: 12, marginLeft: 20 }}>Subscription From {this.formatDate(this.state.subDetails.subscription_start_date)} To {this.formatDate(this.state.subDetails.subscription_end_date)}</p>
                        </div>
                        <div className="subSteps-details2 col-md-6" style={{ paddingRight: 0 }}>
                            <div className="stepCount">
                                <p style={{ color: '#2F80ED', fontWeight: 'bold', fontSize: 12, marginRight: 10 }}>Total Steps - {this.state.subDetails.total_onboarding_steps}</p>
                                <p style={{ color: '#219653', fontWeight: 'bold', fontSize: 12, marginRight: 10 }}>Completed Steps - {this.state.subDetails.completed_onboarding_steps}</p>
                                <p style={{ color: '#EB5757', fontWeight: 'bold', fontSize: 12 }}>Remaining Steps - {this.state.subDetails.remaining_onboarding_steps}</p>
                            </div>
                            <div className="step-actions">
                                <ReactToPrint
                                    trigger={() => {
                                        return <FontAwesomeIcon icon={['fas','print']} size="lg" color="#4D4D4D" style={{ cursor: 'pointer' }} />;
                                    }}
                                    content={() => this.printReference}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="subStepContainer" ref={el => this.printReference = el}>
                        <div className="college-info">
                            <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                            <h5 className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</h5>
                        </div>
                        
                                {
                                    this.state.onboardingStepFetching ?
                                        <Spinner />
                                    :
                                    Object.keys(this.state.onboardingStepList).length > 0 ?
                                    this.state.sequenceIdArray.map((stepId, stepIndex) => {
                                        let step = this.state.onboardingStepList[stepId];
                                        return(
                                            <div className="card stepCard" style={{ borderLeft: step.status == 'pending' ? '5px solid #FF0000' : '5px solid #219653' }}>
                                                
                                                <div className="stepDetailsContainer">
                                                    <div className="stepCount col-md-2" style={{paddingLeft:0}}>
                                                        {stepIndex+1}. <span className={"ml-2 badge "+ step.type+"StepType" }>{step.type.charAt(0).toUpperCase() + step.type.slice(1)}</span>
                                                    </div>
                                                    <div className="stepName col-md-7">
                                                        <p> {step.stepName}</p>
                                                    </div> 
                                                    {
                                                        step.type == "activity" &&
                                                        <div className="col-md-3">
                                                            <div className="completionDateDiv mr-2">
                                                                <div className="muteted" style={{color:"#4F4F4F", fontSize:12}} >Completion Date</div>
                                                                <div className="completionDate">{step.completion_date_readable}</div>
                                                            </div>
                                                            {/* <div className="completionDateDiv mr-2">
                                                                <div className="muteted" style={{color:"#4F4F4F", fontSize:12}} >Completed By</div>
                                                                <div className="completionDate">{step.completion_date_readable}</div>
                                                            </div> */}
                                                            {/* <div className=""></div> */}
                                                        </div>
                                                       
                                                    }
                             
                                                </div>                                                   
                                                {
                                                    step.type == "module" &&                                                   
                                                    Object.keys(step.demoDetails).length>0 ?
                                                    <div className="demoDivContainer">
                                                        <table className="table table-responsive-sm">
                                                            <thead>
                                                                <th style={{ padding: 5 }} >Sr. No.</th>
                                                                <th style={{ padding: 5 }} >Demo Name</th>
                                                                <th style={{ padding: 5 }} >Date</th>
                                                                <th style={{ padding: 5 }} >Conducted By</th>
                                                                <th style={{ padding: 5 }} >No of Present Client Attendees</th>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    Object.values(step.demoDetails).map((demo,demoIndex) => {
                                                                        return (
                                                                            <tr>
                                                                                <td style={{ padding: 5 }} >{demoIndex+1}</td>
                                                                                <td style={{ padding: 5 }} >{demo.meeting_name}</td>
                                                                                <td style={{ padding: 5 }} >{demo.demoDate_readable}</td>
                                                                                <td style={{ padding: 5 }} >{this.showEmployeeName(demo.vmAttendeesNameObject)}</td>
                                                                                <td style={{ padding: 5 }} >{demo.clientAttendeesArray.length - demo.attendeesAttendance.length}</td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    :
                                                    step.type == "module" &&   
                                                    <p className="col-md-12 noDemoMsg">Demo is not scheduled yet.</p>
                                                    
                                                }
                                            </div>
                                        );
                                    })
                                        :
                                            <p className='noStepsMsg'>No onboarding step added for the subscription.</p>
                                }
                    </div>
                </div>
                {/* {
                    this.returnScheduleDemo()
                }
                {
                    this.returnSelectAttendees()
                } */}
                {
                    this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal} 
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal} 
                        />
                }
            </>
        );
    }
}

export default OnboardingSteps;